import { useEffect } from 'react';

/**
 * Registers global keyboard shortcuts. Ignores events when user is typing in an input/textarea.
 * @param {Record<string, () => void>} shortcuts - key: shortcut key, value: handler
 */
export function useKeyboardShortcuts(shortcuts) {
  useEffect(() => {
    function handler(e) {
      const tag = e.target.tagName;
      const isTyping = tag === 'INPUT' || tag === 'TEXTAREA' || e.target.isContentEditable;

      // Allow Escape even when typing
      if (e.key === 'Escape') {
        shortcuts['Escape']?.();
        return;
      }

      if (isTyping) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const fn = shortcuts[e.key];
      if (fn) {
        e.preventDefault();
        fn();
      }
    }

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [shortcuts]);
}
